import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import useRunId from '@/hooks/useRunId.ts';
import { StepRunLogPresentation } from '@/types/stepExecutions.ts';
import { STEP_RUN_LOG_PRESENTATION_KEY } from '@/utils/queryKeys.ts';
import { get_step_run_log_presentation_url } from '@/utils/urls.ts';

const useRetrieveStepRunLogPresentation = (
  stepRunId?: string,
  enabled = true,
): UseQueryResult<StepRunLogPresentation, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();
  const runId = useRunId();

  return useQuery({
    queryKey: STEP_RUN_LOG_PRESENTATION_KEY(automationId, runId, stepRunId),
    queryFn: async () => {
      const response = await apiClient.get<StepRunLogPresentation>(
        get_step_run_log_presentation_url(stepRunId),
      );
      return response.data;
    },
    enabled: !!stepRunId && enabled,
  });
};

export default useRetrieveStepRunLogPresentation;
